import React from 'react';
import { HelmetProvider } from 'react-helmet-async';

import { RecoilRoot } from 'recoil';
import { ThemeProvider } from 'styled-components';

import { GlobalStyle } from 'styles/globals/GlobalStyle';
import theme from 'styles/token/color';

/**
 * @desc 공통 컨텍스트 프로바이더 (Recoil, Theme, Helmet)
 * @param {Object} props
 * @param {JSX.Element} props.children
 * @param {boolean} props.withGlobalStyle - GlobalStyle 적용 여부 (기본값: false)
 */
const ContextProvider = ({ children, withGlobalStyle = false }) => {
  return (
    <HelmetProvider>
      <RecoilRoot>
        <ThemeProvider theme={theme}>
          {withGlobalStyle && <GlobalStyle />}
          {children}
        </ThemeProvider>
      </RecoilRoot>
    </HelmetProvider>
  );
};

export default ContextProvider;
